import { Link } from 'react-router-dom';
import { useState } from 'react';
import { Callout } from '@/components/ui/Callout';
import { Button } from '@/components/ui/Button';
import {
  SAMPLE_DATA_GUIDES,
  isSampleDataEnabled,
  setSampleDataEnabled,
} from '@/core/sampleData/sampleDataPrefs';
import { notify } from '@/core/toast/notify';

interface SampleDataPanelProps {
  className?: string;
  compact?: boolean;
}

export function SampleDataPanel({ className, compact }: SampleDataPanelProps) {
  const [enabled, setEnabled] = useState(isSampleDataEnabled);

  const toggle = () => {
    const next = !enabled;
    setEnabled(next);
    setSampleDataEnabled(next);
    notify.info(next ? 'Sample data guides enabled' : 'Sample data guides hidden');
  };

  return (
    <Callout variant="info" title="Sample data & guided setup" className={className}>
      <p className="mb-3">
        Enable guided demos to explore modules with safe example flows — no production data is modified
        automatically.
      </p>
      <div className="flex flex-wrap items-center gap-2">
        <Button type="button" size="sm" variant={enabled ? 'primary' : 'secondary'} onClick={toggle}>
          {enabled ? 'Sample guides on' : 'Enable sample guides'}
        </Button>
      </div>
      {enabled && !compact && (
        <ul className="mt-4 space-y-2 text-sm">
          {SAMPLE_DATA_GUIDES.map((g) => (
            <li key={g.path}>
              <Link to={g.path} className="text-link">
                {g.label}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </Callout>
  );
}
